import { hideAndRemove } from "../../helpers";
import { toggleSceneObject } from "../../togglers";
import { DEFAULT_COUNTS, DRAG_STEPS, Y_MAP_SHELVES } from "./pos_map";

export const changePolkaStellazhi = (count, verticalOnly = true, initDefault = false, preservedY = null) => {
    const height = servObj.tableSize.tableHeight.current;
    const width = servObj.tableSize.tableWidth.current;
    const depth = servObj.tableSize.tableDepth.current;
    const stellazhName = servObj.tempName;

    const defaultCount = DEFAULT_COUNTS[stellazhName];
    if (!initDefault) count += defaultCount;

    const name = `dopolnitelnaya_polka__stellazh__${stellazhName}__${height}x${width}x${depth}__${count}`;

    const currentQuantity = servObj.activePolkaStellazh.length;
    if (currentQuantity > count) {
        servObj.activePolkaStellazh.forEach((el) => {
            if (el.userData.count > count) {
                hideAndRemove(el);
                servObj.activePolkaStellazh = servObj.activePolkaStellazh.filter((item) => item.name !== el.name);
            }
        });
        return;
    }

    const dragStep = DRAG_STEPS[stellazhName];
    const position = { y: preservedY ?? Y_MAP_SHELVES[stellazhName][height][count] };

    toggleSceneObject({
        allObjects: servObj.allPolkaStellazh,
        activeArray: servObj.activePolkaStellazh,
        name,
        isChecked: true,
        filterActiveFn: (el) => {
            return el.userData.count < count;
        },
        position,
        userData: { name, count, verticalOnly, dragStep },
        isStrictName: true,
    });
};
